<template>
  <div>
      <el-row class="mt-2">
          <b class="font_extralarge">依据支部导出</b>        
      </el-row>
      <!-- 第二部分，上传 -->
      <el-row class="mt-2">
          <b class="font_base">1. 选择支部</b>        
      </el-row>

      <el-row class="mt-2">
        <PartyOrgCascader @onValueChanged="onOrgValueChanged"></PartyOrgCascader>         
      </el-row>


      <el-row>
          <el-button style="margin-top: 12px;" type="primary" @click="publish" :loading="loading">确定</el-button>
      </el-row>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { options as optionsApi } from "@/api/module/studyclass/studyclass";
import { PartyOrgCascader } from "@/views/components/select";
import { exportApi } from "@/api/module/export/export";

export default {
  name: "ExportPartyOrgSche",
  
  mixins: [BaseVue],
  
  components: {
    PartyOrgCascader
  },
  
  data() {
    return {
      partyids: [],
      datas: [],
      haserror: false,
      loading: false
    };
  },
  
  methods: {
    init() {
      // 初始化逻辑
    },
    
    onOrgValueChanged(datas) {
      console.log("onOrgValueChanged", datas);
      this.partyids = datas;
    },
    
    publish() {
      if (!this.partyids || this.partyids.length == 0) {
        this.$message.error("未获得支部数据");
        return;
      }
      
      this.loading = true;
      
      let serverUrl = "/api/manager/export/scheduling/party";
      
      let data = {
        partyids: this.partyids
      };
      
      let date = new Date();
      var Y = date.getFullYear();
      var M = date.getMonth() + 1;
      var D = date.getDate();
      
      let filename = "导出数据" + Y + M + D + ".xls";
      
      this.$message.info("导出中，请稍后！");
      
      exportApi(data, serverUrl)
        .then((res) => {
          this.$message.success("成功导出");
          let data = res.data;
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.$message.error("服务器内部错误!");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  
  created() {
    // 组件创建时的逻辑
  }
};
</script>


<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>